const publications = {
  cah: {
    articulos: {
      arbitrados: {
        route: "publicaciones/articulos/arbitrados",
        slug: "arbitrados",
        title: "Artículos Arbitrados",
        tag: "Arbitrados",
        // FIXME: Cambiar ID
        collection_id: "164c4cd3-2311-4206-b4d6-047ffdd2c0fd",
        content: () => [
          <p>
            Revise esta colección en el{" "}
            <a
              href="https://repositorio.igp.gob.pe/handle/20.500.12816/4985"
              target="_blank"
            >
              Repositorio Geofísico Nacional
            </a>
          </p>,
        ],
      },
      divulgacion: {
        route: "publicaciones/articulos/divulgacion",
        slug: "divulgacion",
        title: "Artículos de Divulgación",
        tag: "Divulgación",
        // FIXME: Cambiar ID
        collection_id: "a89d1ff1-988c-406f-9aa7-093f273bb8a1",
        content: () => [
          <p>
            Revise esta colección en el{" "}
            <a
              href="https://repositorio.igp.gob.pe/handle/20.500.12816/4987"
              target="_blank"
            >
              Repositorio Geofísico Nacional
            </a>
          </p>,
        ],
      },
      avances: {
        route: "publicaciones/articulos/avances",
        slug: "avances",
        title: "Artículos de Avances de Investigación",
        tag: "Avances de Investigación",
        // FIXME: Cambiar ID
        collection_id: "a1320bd7-e849-4d3f-ba41-f8a2cfdff759",
        content: () => [
          <p>
            Revise esta colección en el{" "}
            <a
              href="https://repositorio.igp.gob.pe/handle/20.500.12816/4986"
              target="_blank"
            >
              Repositorio Geofísico Nacional
            </a>
          </p>,
        ],
      },
    },
    facilidades: {
      dinamica: {
        route: "publicaciones/articulos/dinamica-fluidos",
        slug: "dinamica-fluidos",
        title: "Dinámica de Fluidos Geofísicos",
        tag: "Dinámica de Fluidos",
        // FIXME: Cambiar ID
        collection_id: "7be5bf4c-b872-45e9-9584-7b0ef9348826",
        content: () => [
          <p>
            Revise esta colección en el{" "}
            <a href="https://repositorio.igp.gob.pe/handle/20.500.12816/4986">
              Repositorio Geofísico Nacional
            </a>
          </p>,
        ],
      },
      microfisica: {
        route: "publicaciones/articulos/microfisica-atmosferica",
        slug: "microfisica-atmosferica",
        title: "Microfísica Atmosférica y Radiación",
        tag: "Dinámica de Fluidos",
        // FIXME: Cambiar ID
        collection_id: "0fef5ba3-a95d-44db-b552-e6d3c328fdb8",
        content: () => [
          <p>
            Revise esta colección en el{" "}
            <a href="https://repositorio.igp.gob.pe/handle/20.500.12816/4986">
              Repositorio Geofísico Nacional
            </a>
          </p>,
        ],
      },
    },
    informes: {
      tecnicos: {
        route: "publicaciones/informes/tecnicos",
        slug: "tecnicos",
        title: "Informes Técnicos",
        tag: "Informes Técnicos",
        // FIXME: Cambiar ID
        collection_id: "256eeaba-4bd9-44ee-8277-6dd2a699dd3c",
        content: () => [
          <p>
            Revise esta colección en el{" "}
            <a href="https://repositorio.igp.gob.pe/handle/20.500.12816/5356">
              Repositorio Geofísico Nacional
            </a>
          </p>,
        ],
      },
    },
    academicos: {
      tesis: {
        route: "publicaciones/academicos/tesis",
        slug: "tesis",
        title: "Tesis",
        tag: "Tesis",
        // FIXME: Cambiar ID
        collection_id: "ede0784a-010b-4b34-8563-5bf3a95658da",
        content: () => [
          <p>
            Revise esta colección en el{" "}
            <a href="https://repositorio.igp.gob.pe/handle/20.500.12816/4541">
              Repositorio Geofísico Nacional
            </a>
          </p>,
        ],
      },
    },
  },
};

function getPublications(program_id) {
  return publications[program_id] || publications["cah"];
}

export { getPublications };
